import { render, staticRenderFns } from "./MyBooks.vue?vue&type=template&id=67379275&scoped=true"
import script from "./MyBooks.vue?vue&type=script&lang=js"
export * from "./MyBooks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67379275",
  null
  
)

export default component.exports